import { render, staticRenderFns } from "./coupenUser.vue?vue&type=template&id=03956ef7"
import script from "./coupenUser.vue?vue&type=script&lang=js"
export * from "./coupenUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports